import { ModalPropsForType } from 'containers/Modal/ModalPropsForType';
import { ModalType } from 'containers/Modal/ModalType';

import { HideModalAction, ShowModalAction } from './modal';

export function showModal<T extends ModalType>(
  type: T,
  props: ModalPropsForType<T>,
): ShowModalAction {
  return {
    type: 'MODAL_SHOW',
    payload: { type, props },
  };
}

export function hideModal(): HideModalAction {
  return { type: 'MODAL_HIDE' };
}
